let CodeMirror = require('codemirror/lib/codemirror.js');

import { LinksHandler } from './links/links-handler';
import { LinksDetector } from './links/links-detector';
import { AttachmentType } from './attachments/attachment-types';
import { CodemirrorSpellChecker, LAST_SET_SPELLCHECKER_LANG_LS_KEY } from '../../../app/shared/components/single-message-editor/codemirror-spellchecker/codemirror-spellchecker';
import { CharactersCounter } from './characters-counter/characters-counter';
import { MarksHelper } from '../../../app/shared/components/single-message-editor/code-mirror-wrapper/marks-helper';

codemirrorAndToolbarDirective.$inject = ['$timeout', '$translate', '$uibModal', 'MediasFactory',
  'AlertingFactory', 'LocalStorageFactory', 'AngularHunspellService'];
export function codemirrorAndToolbarDirective($timeout, $translate, $uibModal, MediasFactory,
  AlertingFactory, LocalStorageFactory, AngularHunspellService) {

  return {
    restrict: 'E',
    template: require('./codemirror-and-toolbar.directive.html'),
    require: 'codemirrorAndToolbar',
    scope: {
      companyId: '=',
      site: '=',
      initialModel: '<?', // This is watched (and will overwrite the editor content if assigned to a different object by the parent scope)
      modelAccessor: '<', // must be set to a variable with a value of {} by the parent; the link() function below will add getter functions to it
      isEmpty: '=?',      // if present, will be updated to reflect whether the text content is currently empty
      isTooLong: '=?',    // if present, will be updated to reflect whether the text content is currently longer than the configured limit
      uploadingFileAttachment: '=?isUploading',    // if present, will be updated to reflect whether a file is currently being uploaded
      options: '=?'       // an object describing which attachment types should be offered, and which language should be used to spell check (if any)
    },
    controller: function () { // we need to declare the controller explicitely so that it can be injected in the link function
      return this;
    },
    link: function link($scope, element, attrs, controller) {

      $scope.emojiPickerClicked = emojiPickerClicked;
      $scope.addAttachment = addAttachment;
      $scope.removeAttachment = removeAttachment;
      $scope.languageCodeSelected = languageCodeSelected;
      $scope.insertMention = insertMention;

      let editor = null;
      let linksHandler = null;
      let linksDetector = null;
      let spellChecker = null;

      init();


      function emojiPickerClicked() {
        $uibModal.open({
          animation: true,
          size: 'lg',
          template: require('../emoji-picker/emojiPicker2.modal.html'),
          controller: 'emojiPicker2ModalController',
        }).result.then(result => {
          const cursor = editor.getDoc().getCursor();
          editor.getDoc().replaceRange(result.emojiText, cursor);
          editor.focus();
        });
      }

      function insertMention() {
        let cursor = editor.getDoc().getCursor();
        const mentionPlaceholderForBackend = '[user]';
        editor.getDoc().replaceRange(mentionPlaceholderForBackend, cursor);
        MarksHelper.markMention(editor, cursor, mentionPlaceholderForBackend, $scope.options.username);
        cursor = editor.getDoc().getCursor();
        editor.getDoc().replaceRange(' ', cursor); // add an extra space after the mention, but not inside the replaced range
        editor.focus();
      }

      // Options enable various attachement types,
      // but the user is offered to add only one attachement of each type
      function updateOfferedAttachmentTypes() {
        const currentTypeNames = $scope.attachments.map(attachment => attachment.type);
        $scope.offeredAttachmentTypes = $scope.enabledAttachmentTypes
          .filter(type => !currentTypeNames.includes(type.typeName));
      }


      function addAttachment(attachementType) {
        attachementType.addAttachment($translate, $uibModal, element, $scope.attachments, $scope.companyId, $scope.site.id);
      }


      function removeAttachment(attachment) {
        $scope.attachments.splice($scope.attachments.indexOf(attachment), 1);
      }


      function languageCodeSelected(code) {
        $scope.options.lang = code; // the $watch set in initSpellChecker() will call changeSpellCheckerLanguage()
      }

      /** Triggers a rebuild of hunspell's disctionnary with the given language */
      function changeSpellCheckerLanguage(code) {
        spellChecker.setLanguageCode(code);
      }

      /**
       * Informs the parent scope whether the editor is empty or not (they might use it for validation for example)
       */
      function updateIsEmptyStatus() {
        $scope.isEmpty = editor.getDoc().getValue() === "";
      }

      /**
       * If the parent scope provides initial values for the content of the editor and its attachements,
       * let's update our scope and our CodeMirror editor accordingly.
       * The parent scope can overwrite the editor content at a later stage if necessary
       */
      function updateOnParentModelChange(newModel) {
        const text = newModel && newModel.text ? newModel.text : '';
        const links = newModel && newModel.links ? newModel.links : [];
        // Copy the attachments over, otherwise deleting one from the editor also deletes it from the favorite preview
        const attachments = newModel && newModel.attachments ? angular.copy(newModel.attachments) : [];

        editor.getDoc().setValue(text);
        linksHandler.setWrapFromModel(links);
        $scope.attachments = attachments;

        maybeConvertPicturesIdsToAttachment(newModel);
        maybeInsertMentionIfEmptyMessage();

        if (newModel && newModel.onModelUpdated) {
          newModel.onModelUpdated();
        }
        editor.focus();
      }

      // Support editor1 picture format, for example if a favorite answer has been recorded in the DB with the editor1 format
      function maybeConvertPicturesIdsToAttachment(newModel) {
        if (newModel
          && newModel.picturesIds
          && newModel.picturesIds.length > 0
          && !$scope.attachments.find(attachment => attachment.type === 'picture')) {

          $scope.attachments.push({
            'type': 'picture',
            'value': {
              'pictureId': newModel.picturesIds[0]
            }
          });
        }
      }


      function maybeInsertMentionIfEmptyMessage() {
        if ($scope.options.insertMentionIfEmptyInitialMessage
          && (!$scope.initialModel || !$scope.initialModel.text)) {

          insertMention();
        }
      }


      function onLeftClick(event) {
        let coordinate = { left: event.pageX, top: event.pageY };
        let pos = editor.coordsChar(coordinate);
        let marksAtClick = editor.getDoc().findMarksAt(pos);
        if (marksAtClick.length > 0 && MarksHelper.targetIsMark(event)) {
          spellChecker.onLeftMouseButtonDown(marksAtClick);
          linksDetector.onLeftMouseButtonDown(marksAtClick);
          element.find('editor2-context-menu').css({
            'left': event.clientX - element.offset().left,
            'top': event.clientY - element.offset().top
          });
          $timeout(() => {
            element.find('.context-menu-hidden-trigger').click();
          }, 10); // give angularjs a chance to propagate the left and top to the DOM  
        }
      }


      function initEditor() {

        editor = CodeMirror.fromTextArea(element.find('textarea')[0], {
          'lineWrapping': true,
          'cursorHeight': 0.85,

          // U+200D (zero-width joiner) is part of many complex emojis, let's avoid CM wrapping it inside a <span class="cm-invalidchar">
          'specialChars': /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200c\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/,

          // without this the hidden textarea hack for copy/paste in browser context menu works erratically on FF
          'resetSelectionOnContextMenu': false,

          // some 3rd pary tools are only compatible with the 'contenteditable' mode
          'inputStyle': 'contenteditable'
        });

        editor.setOption('maxCharsNumber', $scope.options.maxCharsNumber)

        $scope.$watch('initialModel', newValue => updateOnParentModelChange(newValue));
        $scope.addDMLink = {
          'isChecked': false
        };
      }


      /**
       * There is no two-way data-binding for the editor:
       * the editor2 directive retreives the content of this single-message editor with the functions exposed below.
       */
      function initModelAccessors() {
        $scope.modelAccessor.getModel = () => ({
          'text': editor.getDoc().getValue(),
          'links': linksHandler.getLinks(),
          'attachments': $scope.attachments,
          'addDMLink': $scope.addDMLink.isChecked,
        });
      }


      function initIsEmptyUpdates() {
        if ($scope.hasOwnProperty('isEmpty')) {
          updateIsEmptyStatus();
          editor.on('change', () => $scope.$applyAsync(() => updateIsEmptyStatus()));
        }
      }


      function initOfferedAttachmentTypes() {
        $scope.enabledAttachmentTypes = AttachmentType.enabledTypes($scope.options);
        $scope.enabledAttachmentTypes.forEach(type => type.initScope($scope, MediasFactory, AlertingFactory, $scope.companyId, $scope.site.id));
        $scope.$watch('attachments.length', () => updateOfferedAttachmentTypes());
        $scope.filenames = {};
      }


      function initSpellChecker() {
        const spellCheckerContext = {
          getLastSetSpellcheckerLang: () => LocalStorageFactory.getItem(LAST_SET_SPELLCHECKER_LANG_LS_KEY),
          saveLastSetSpellcheckerLang: lang => LocalStorageFactory.setItem(LAST_SET_SPELLCHECKER_LANG_LS_KEY, lang),
          onSpellSuggestionsFromOutsideOfAngular: suggestions => $scope.$apply(() => $scope.spellSuggestions = suggestions),
          onSpellSuggestions: suggestions => $scope.spellSuggestions = suggestions,
        };
        spellChecker = new CodemirrorSpellChecker(editor, AngularHunspellService, spellCheckerContext);
        $scope.spellChecker = spellChecker; // the template needs it to display the flags
        $scope.$watch('options.lang', changeSpellCheckerLanguage); // this will trigger a spellcheck
        $scope.$on('$destroy', () => spellChecker.cleanUp());
      }

      function initCharactersCounter() {
        if ($scope.options.maxCharsNumber > 0) {
          const charactersCounter = new CharactersCounter(editor, $scope);
          charactersCounter.updateCharactersCountAndMark();
        }
      }


      function initLinkDetection() {
        let isShortnerDisabled = $scope.options.isShortnerDisabled;
        linksHandler = new LinksHandler(editor, $scope, isShortnerDisabled);
        linksDetector = new LinksDetector(editor, linksHandler, isShortnerDisabled);
        linksDetector.initLinksDetection();
      }


      function initFocus() {
        editor.on('focus', () => element.addClass('focused'));
        editor.on('blur', () => element.removeClass('focused'));
        editor.focus();
      }


      function initContextMenu() {
        // will be called directly by the context menu directive
        controller.spellSuggestionClicked = replacement => spellChecker.replacementClicked(replacement);
        controller.contextMenuClosing = () => { editor.focus(); };
        editor.on("mousedown", (editor, event) => {
          if (event.button === 0) {
            onLeftClick(event);
          }
        });
      }

      function initOnDestroy() {
        // let's prevent CodeMirrors leaking when moving back from task process to tasks list
        $scope.$on('$destroy', () => {
          if (typeof editor._handlers === 'object') {
            for (let type in editor._handlers) {
              // we use _handlers even if it is private to CodeMirror's implementation,
              // because it would clutter our code to track the ~8 handlers as separate functions
              editor._handlers[type].forEach(handler => editor.off(type, handler));
            }
          }
          // revert <form>'s submit attribute
          editor.toTextArea();

          if (editor.display && editor.display.wrapper) {
            // somehow, some internal DOM nodes don't seem to be garbage collected, 
            // and one of them (the wrapper) has a reference to its code mirror object
            delete editor.display.wrapper.CodeMirror;
          }

          // Angularjs doesn't seem to delete the $scope object when it transitions back to the parent state
          editor = null;
          linksHandler = null;
          linksDetector = null;
          spellChecker = null;
        });
      }


      function init() {
        initEditor();
        initLinkDetection();
        initModelAccessors();
        initIsEmptyUpdates();
        initOfferedAttachmentTypes();
        initSpellChecker();
        initCharactersCounter();
        initFocus();
        initContextMenu();
        initOnDestroy();
      }
    }
  }
}
